import React, { useState } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ThemeSwitch from './ThemeSwitch';
import NotificationBell from './NotificationBell';
import InstallPrompt from './InstallPrompt';
import { LayoutDashboard, Users, BarChart3, Settings, LogOut, Menu, X, Shield, Wallet, Building2, Receipt, RefreshCw, TrendingDown, Repeat, CreditCard } from 'lucide-react';

const navItems = [
  { grupo: 'CRM' },
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/clients', icon: Users, label: 'Clientes CRM' },
  { to: '/reports', icon: BarChart3, label: 'Reportes CRM' },
  { grupo: 'Agencia' },
  { to: '/agencia', icon: Wallet, label: 'Panel', end: true },
  { to: '/agencia/clientes', icon: Building2, label: 'Clientes' },
  { to: '/agencia/cobros', icon: Receipt, label: 'Cobros' },
  { to: '/agencia/abonos', icon: Repeat, label: 'Abonos' },
  { to: '/agencia/renovaciones', icon: RefreshCw, label: 'Renovaciones' },
  { to: '/agencia/egresos', icon: TrendingDown, label: 'Egresos' },
  { to: '/agencia/finanzas', icon: BarChart3, label: 'Finanzas' },
  { to: '/agencia/medios-pago', icon: CreditCard, label: 'Medios de pago' },
  { grupo: '' },
  { to: '/settings', icon: Settings, label: 'Configuración' },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div style={{ display:'flex', height:'100vh', overflow:'hidden' }}>
      <button onClick={() => setMobileOpen(!mobileOpen)} className="mobile-menu-btn" style={{ position:'fixed', top:12, left:12, zIndex:1001, background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:8, padding:8, color:'var(--text-primary)', display:'none' }}>{mobileOpen ? <X size={20}/> : <Menu size={20}/>}</button>
      {mobileOpen && <div style={{position:'fixed',inset:0,background:'var(--overlay)',zIndex:998}} onClick={()=>setMobileOpen(false)}/>}
      <aside className="sidebar" style={{ width:250, minWidth:250, height:'100vh', background:'var(--bg-secondary)', borderRight:'1px solid var(--border)', display:'flex', flexDirection:'column', position: mobileOpen ? 'fixed' : 'relative', zIndex:999 }}>
        <div style={{ padding:'24px 20px', borderBottom:'1px solid var(--border)' }}>
          <img src="/logoudream.png" alt="uDream" style={{ height:44, marginBottom:6 }} onError={e => { e.target.style.display='none'; }} />
          <div style={{ fontSize:14, fontWeight:800, color:'var(--text-primary)', letterSpacing:1, marginTop:6, display:'flex', alignItems:'center', gap:6 }}><Shield size={14} style={{ color:'var(--accent)' }}/> SUPER ADMIN</div>
          <div style={{ fontSize:11, color:'var(--text-muted)', fontWeight:500, marginTop:2 }}>Panel de administración</div>
        </div>
        <nav style={{ flex:1, padding:'12px 10px', display:'flex', flexDirection:'column', gap:2, overflowY:'auto' }}>
          {navItems.map(item => item.grupo !== undefined ? (
            <div key={'g' + item.grupo} style={{ fontSize:10, fontWeight:700, letterSpacing:1, color:'var(--text-muted)', textTransform:'uppercase', padding:'12px 14px 4px' }}>{item.grupo}</div>
          ) : (<NavLink key={item.to} to={item.to} end={item.end} onClick={() => setMobileOpen(false)} style={({ isActive }) => ({ display:'flex', alignItems:'center', gap:12, padding:'10px 14px', borderRadius:10, fontSize:14, fontWeight: isActive ? 600 : 500, color: isActive ? '#fff' : 'var(--text-secondary)', background: isActive ? 'var(--accent)' : 'transparent', textDecoration:'none', transition:'all 0.15s' })}><item.icon size={18}/> {item.label}</NavLink>))}
        </nav>
        <div style={{ padding:'16px', borderTop:'1px solid var(--border)' }}>
          <div style={{ fontSize:13, color:'var(--text-secondary)', marginBottom:8 }}>{user?.display_name || user?.username}</div>
          <button onClick={logout} className="btn btn-ghost" style={{ width:'100%', justifyContent:'flex-start', gap:8 }}><LogOut size={16}/> Cerrar sesión</button>
          <ThemeSwitch />
        </div>
      </aside>
      <main style={{ flex:1, overflow:'auto', padding:28 }}><Outlet/></main>
      <NotificationBell />
      <InstallPrompt />
      <style>{`@media (max-width: 768px) { .sidebar { position: fixed !important; transform: translateX(${mobileOpen ? '0' : '-100%'}) !important; transition: transform 0.25s; } .mobile-menu-btn { display: block !important; } main { padding: 16px !important; padding-top: 56px !important; } .sidebar > div:first-child { padding-top: 56px !important; } }`}</style>
    </div>
  );
}
